export const mapTheme = [
  {
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#6b7f8f'
      }
    ]
  },
  {
    featureType: 'landscape.natural.landcover',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#ffffff'
      }
    ]
  },
  {
    featureType: 'water',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#d0e8fb'
      }
    ]
  },
  {
    featureType: 'poi.business',
    stylers: [{ visibility: 'off' }]
  }
]
